import React from "react";
import { monthConverter } from "utils/common";
import { UserLevel } from "utils/constant";
import { getInterpretasi } from "utils/helpers";

const TableComponent = ({
  currentLevel,
  reportsData,
  tableRef,
  reportInfo,
}) => {
  // Visibilitas kolom tanggal berdasarkan level radio button
  // Faskes    -> hanya tanggal slide dikirim faskes
  // District  -> faskes + kab/kota (dikirim ke provinsi)
  // Province  -> faskes + kab/kota + provinsi (dikirim ke nasional)
  // National  -> semua (faskes, kab/kota, provinsi)
  // LabTier2  -> mengikuti District (faskes + kab/kota)
  // LabTier3  -> mengikuti Province (faskes + kab/kota + provinsi)
  const showFaskesDate = true;
  const showKabkotaDate = [
    UserLevel.District,
    UserLevel.Province,
    UserLevel.National,
    UserLevel.LabTier2,
    UserLevel.LabTier3,
  ].includes(currentLevel);
  const showProvDate = [
    UserLevel.Province,
    UserLevel.National,
    UserLevel.LabTier3,
  ].includes(currentLevel);
  const dateColCount =
    (showFaskesDate ? 1 : 0) +
    (showKabkotaDate ? 1 : 0) +
    (showProvDate ? 1 : 0);

  const faskesDateLabel =
    currentLevel === UserLevel.Fasyankes
      ? "Tanggal Slide Dikirim"
      : currentLevel === UserLevel.National
      ? "Tanggal slide dikirim dari faskes"
      : "Tanggal slide dikirim faskes";
  const kabkotaDateLabel = [UserLevel.District, UserLevel.LabTier2].includes(
    currentLevel
  )
    ? "Tanggal slide dikirim ke provinsi"
    : currentLevel === UserLevel.National
    ? "Tanggal slide dikirim dari kabko"
    : "Tanggal slide dikirim kab/kota";
  const provDateLabel =
    currentLevel === UserLevel.National
      ? "Tanggal slide dikirim dari provinsi"
      : "Tanggal slide dikirim ke nasional";

  const renderTableByLevel = () => {
    switch (currentLevel) {
      case UserLevel.LabTier2:
        return (
          <>
            <thead>
              <tr>
                <th>No</th>
                <th>Nama</th>
                <th>Kode Slide</th>
                <th>Slide</th>
                {showFaskesDate && <th>{faskesDateLabel}</th>}
                {showKabkotaDate && <th>{kabkotaDateLabel}</th>}
                {showProvDate && <th>{provDateLabel}</th>}
                <th>Tanggal slide diperiksa oleh tingkat 2</th>
                <th>Hasil verifikasi tingkat 2</th>
                <th>Interpretasi hasil - tingkat 2</th>
                <th>Interpretasi hasil - tingkat 3</th>
                <th>Interpretasi Akurasi Spesies - tingkat 2</th>
                <th>Interpretasi Akurasi Spesies - tingkat 3</th>
                <th>Ketebalan SD Tebal - Tingkat 2</th>
                <th>Ketebalan SD Tipis - Tingkat 2</th>
                <th>Pewarnaan - Tingkat 2</th>
                <th>Ketebalan SD Tebal - Tingkat 3</th>
                <th>Ketebalan SD Tipis - Tingkat 3</th>
                <th>Pewarnaan - Tingkat 3</th>
              </tr>
            </thead>
            <tbody>
              {reportsData.length !== 0 ? (
                reportsData?.map((item, index) => {
                  let parasyte = item?.parasyte ?? [];
                  if (item?.slide === "negatif") parasyte = ["Negatif"];
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item?.name}</td>
                      <td>{item?.slide_code}</td>
                      <td style={{ textTransform: "capitalize" }}>
                        {item?.slide}
                      </td>
                      {showFaskesDate && <td>{item?.tgl_slide_dikirim}</td>}
                      {showKabkotaDate && (
                        <td>{item?.tgl_slide_dikirim_kabkota}</td>
                      )}
                      {showProvDate && <td>{item?.tgl_slide_dikirim_prov}</td>}
                      <td>{item?.tgl_slide_diperiksa_kabkota}</td>
                      <td>{item?.hasil_kabkota}</td>
                      <td>{getInterpretasi(item?.hasil_kabkota, parasyte)}</td>
                      <td>{getInterpretasi(item?.hasil_prov, parasyte)}</td>
                      <td>{item?.interpretasi_akurasi_spesies_tier2 ?? ""}</td>
                      <td>{item?.interpretasi_akurasi_spesies_tier3 ?? ""}</td>
                      <td>{item?.ketebalan_sd_tebal_kabkota}</td>
                      <td>{item?.ketebalan_sd_tipis_kabkota}</td>
                      <td>{item?.pewarnaan_kabkota}</td>
                      <td>{item?.ketebalan_sd_tebal_prov}</td>
                      <td>{item?.ketebalan_sd_tipis_prov}</td>
                      <td>{item?.pewarnaan_prov}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={16 + dateColCount} style={{ textAlign: "center" }}>
                    Tidak ada data
                  </td>
                </tr>
              )}
            </tbody>
          </>
        );
      case UserLevel.LabTier3:
        return (
          <>
            <thead>
              <tr>
                <th>No</th>
                <th>Nama</th>
                <th>Kode Slide</th>
                <th>Slide</th>
                {showFaskesDate && <th>{faskesDateLabel}</th>}
                {showKabkotaDate && <th>{kabkotaDateLabel}</th>}
                {showProvDate && <th>{provDateLabel}</th>}
                <th>Tanggal slide diperiksa oleh tingkat 3</th>
                <th>Hasil verifikasi tingkat 3</th>
                <th>Interpretasi hasil - tingkat 2</th>
                <th>Interpretasi hasil - tingkat 3</th>
                <th>Interpretasi Akurasi Spesies - tingkat 2</th>
                <th>Interpretasi Akurasi Spesies - tingkat 3</th>
                <th>Ketebalan SD Tebal - Tingkat 2</th>
                <th>Ketebalan SD Tipis - Tingkat 2</th>
                <th>Pewarnaan - Tingkat 2</th>
                <th>Ketebalan SD Tebal - Tingkat 3</th>
                <th>Ketebalan SD Tipis - Tingkat 3</th>
                <th>Pewarnaan - Tingkat 3</th>
              </tr>
            </thead>
            <tbody>
              {reportsData.length !== 0 ? (
                reportsData?.map((item, index) => {
                  let parasyte = item?.parasyte ?? [];
                  if (item?.slide === "negatif") parasyte = ["Negatif"];
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item?.name}</td>
                      <td>{item?.slide_code}</td>
                      <td style={{ textTransform: "capitalize" }}>
                        {item?.slide}
                      </td>
                      {showFaskesDate && <td>{item?.tgl_slide_dikirim}</td>}
                      {showKabkotaDate && (
                        <td>{item?.tgl_slide_dikirim_kabkota}</td>
                      )}
                      {showProvDate && <td>{item?.tgl_slide_dikirim_prov}</td>}
                      <td>{item?.tgl_slide_diperiksa_prov}</td>
                      <td>{item?.hasil_prov}</td>
                      <td>{getInterpretasi(item?.hasil_kabkota, parasyte)}</td>
                      <td>{getInterpretasi(item?.hasil_prov, parasyte)}</td>
                      <td>{item?.interpretasi_akurasi_spesies_tier2 ?? ""}</td>
                      <td>{item?.interpretasi_akurasi_spesies_tier3 ?? ""}</td>
                      <td>{item?.ketebalan_sd_tebal_kabkota}</td>
                      <td>{item?.ketebalan_sd_tipis_kabkota}</td>
                      <td>{item?.pewarnaan_kabkota}</td>
                      <td>{item?.ketebalan_sd_tebal_prov}</td>
                      <td>{item?.ketebalan_sd_tipis_prov}</td>
                      <td>{item?.pewarnaan_prov}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={16 + dateColCount} style={{ textAlign: "center" }}>
                    Tidak ada data
                  </td>
                </tr>
              )}
            </tbody>
          </>
        );
      default:
        return (
          <>
            <thead>
              <tr>
                <th>No</th>
                {[
                  UserLevel.National,
                  UserLevel.Province,
                  UserLevel.LabTier3,
                ].includes(currentLevel) && <th>Provinsi</th>}
                <th>Kab/Kota</th>
                {[
                  UserLevel.District,
                  UserLevel.Fasyankes,
                  UserLevel.LabTier2,
                ].includes(currentLevel) && <th>Fasyankes</th>}
                <th>Nama</th>
                <th>Kode slide</th>
                <th>Slide</th>
                {showFaskesDate && <th>{faskesDateLabel}</th>}
                {showKabkotaDate && <th>{kabkotaDateLabel}</th>}
                {showProvDate && <th>{provDateLabel}</th>}
                <th>Tanggal slide diperiksa oleh tingkat 2</th>
                <th>Tanggal slide diperiksa oleh tingkat 3</th>
                <th>Hasil pemeriksaan fasyankes (regmal 1)</th>
                <th>Hasil verifikasi tingkat 2</th>
                <th>Hasil verifikasi tingkat 3</th>
                <th>Interpretasi hasil - tingkat 2</th>
                <th>Interpretasi hasil - tingkat 3</th>
                <th>Interpretasi Akurasi Spesies - tingkat 2</th>
                <th>Interpretasi Akurasi Spesies - tingkat 3</th>
                <th>Ketebalan SD Tebal - Tingkat 2</th>
                <th>Ketebalan SD Tipis - Tingkat 2</th>
                <th>Pewarnaan - Tingkat 2</th>
                <th>Ketebalan SD Tebal - Tingkat 3</th>
                <th>Ketebalan SD Tipis - Tingkat 3</th>
                <th>Pewarnaan - Tingkat 3</th>
              </tr>
            </thead>
            <tbody>
              {reportsData.length !== 0 ? (
                reportsData?.map((item, index) => {
                  let parasyte = item?.parasyte ?? [];
                  if (item?.slide === "negatif") parasyte = ["Negatif"];
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      {[
                        UserLevel.National,
                        UserLevel.Province,
                        UserLevel.LabTier3,
                      ].includes(currentLevel) && (
                        <td>{item?.province_id?.split("|")[1]}</td>
                      )}
                      <td>{item?.district_id?.split("|")[1]}</td>
                      {[
                        UserLevel.District,
                        UserLevel.Fasyankes,
                        UserLevel.LabTier2,
                      ].includes(currentLevel) && (
                        <td>{item?.fasyankes_id?.split("|")[1]}</td>
                      )}
                      <td>{item?.name}</td>
                      <td>{item?.slide_code}</td>
                      <td style={{ textTransform: "capitalize" }}>
                        {item?.slide}
                      </td>
                      {showFaskesDate && <td>{item?.tgl_slide_dikirim}</td>}
                      {showKabkotaDate && (
                        <td>{item?.tgl_slide_dikirim_kabkota}</td>
                      )}
                      {showProvDate && <td>{item?.tgl_slide_dikirim_prov}</td>}
                      <td>{item?.tgl_slide_diperiksa_kabkota}</td>
                      <td>{item?.tgl_slide_diperiksa_prov}</td>
                      <td>{parasyte?.join(", ") ?? ""}</td>
                      <td>{item?.hasil_kabkota}</td>
                      <td>{item?.hasil_prov}</td>
                      <td>{getInterpretasi(item?.hasil_kabkota, parasyte)}</td>
                      <td>{getInterpretasi(item?.hasil_prov, parasyte)}</td>
                      <td>{item?.interpretasi_akurasi_spesies_tier2 ?? ""}</td>
                      <td>{item?.interpretasi_akurasi_spesies_tier3 ?? ""}</td>
                      <td>{item?.ketebalan_sd_tebal_kabkota}</td>
                      <td>{item?.ketebalan_sd_tipis_kabkota}</td>
                      <td>{item?.pewarnaan_kabkota}</td>
                      <td>{item?.ketebalan_sd_tebal_prov}</td>
                      <td>{item?.ketebalan_sd_tipis_prov}</td>
                      <td>{item?.pewarnaan_prov}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={21 + dateColCount}>Tidak ada data</td>
                </tr>
              )}
            </tbody>
          </>
        );
    }
  };

  let levelName = "";
  if (currentLevel === UserLevel.National) {
    levelName = "Nasional";
  } else if ([UserLevel.Province, UserLevel.LabTier3].includes(currentLevel)) {
    levelName = "Provinsi";
  } else if ([UserLevel.District, UserLevel.LabTier2].includes(currentLevel)) {
    levelName = "Kabupaten/Kota";
  } else {
    levelName = "Fasyankes";
  }

  let periodeName = "";
  if (reportInfo?.statusPeriode === "yearly") {
    periodeName = "Tahunan";
  } else {
    periodeName = "Bulanan";
  }

  let data = reportInfo?.fasyankes;
  let parts = data?.split(",");
  let faskesName = parts?.map(function (part) {
    return part?.split("|")[1];
  });
  let result = faskesName?.join(", ");

  return (
    <div
      className="table-table-responsive"
      ref={tableRef}
    >
      <table>
        <tr style={{ border: "none", padding: 0 }}>
          <th style={{ border: "none", paddingBottom: "0" }}>
            <h3>SISMAL v3, VERIFIKASI UJI SILANG</h3>
          </th>
        </tr>
      </table>
      <table>
        <tr style={{ border: "none" }}>
          <th
            width="200"
            style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}
          >
            Periode Laporan
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {periodeName}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Tahun
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {reportInfo?.periode?.year}
          </th>
        </tr>
        {reportInfo?.statusPeriode === "monthly" && (
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Bulan
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {monthConverter(reportInfo?.periode?.month_start)} - {monthConverter(reportInfo?.periode?.month_end)}
            </th>
          </tr>
        )}
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Level
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {levelName}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Provinsi
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            :{" "}
            {!reportInfo?.province
              ? "Semua Provinsi"
              : reportInfo?.province?.split("|")[1]}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Kab/Kota
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            :{" "}
            {!reportInfo?.district
              ? "Semua Kab/Kota"
              : reportInfo?.district?.split("|")[1]}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0 }}>Fasyankes</th>
          <th style={{ border: "none", paddingTop: 0 }}>
            : {!reportInfo?.fasyankes ? "Semua Fasyankes" : result}
          </th>
        </tr>
      </table>
      <table>{renderTableByLevel()}</table>
    </div>
  );
};

export default TableComponent;
